import { render, staticRenderFns } from "./MessageIndexContent.vue?vue&type=template&id=5d6f7bde&"
import script from "./MessageIndexContent.vue?vue&type=script&lang=js&"
export * from "./MessageIndexContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports